<script>
  import { dataset, regionLabel } from "../stores.js";
  import RoundSelect from "./RoundSelect.svelte";

  export let active;

  let items = [
    { name: "Map", url: "" },
    { name: "Interventions", url: "interventions" },
    { name: "Country/Analysis", url: "analysis" },
    { name: "Downloads", url: "downloads" },
    //{ name: "Tools", url: "tools" },
  ];

  let selectedRound = "round-2";

  $: countries = $dataset
    ? Object.values($dataset.countries).filter((a) => a.available == true)
    : [];

  $: regions = $dataset ? Object.keys($dataset.regions) : [];
  function filterCountry(event) {
    let v = this.value;
    let cs = countries.filter((a) => a.country == v);
    if (cs) window.location.hash = "/profile/" + cs[0].iso;
  }
</script>
<!-- Top Bar -->
<aside class="beta-bar">
  <div class="container-fluid wrap flex between-xs">
    <h1 class="loga">World Health Organization</h1>
    <div class="btn-beta">Beta Version</div>
  </div>
</aside>

<header class="top-bar">
  <nav class="container-fluid wrap">
    <input
      type="checkbox"
      class="btn-menu"
      id="main-menu-checkbox"
      aria-label="Toggle navigation"
    />
    
    <section class="top-bar-left">
      <ul class="main-menu">
        <!-- <li>
          <a href="https://www.who.int/data/data-collection-tools/score"
            >Home</a
          >
        </li> -->
        {#each items as { name, url }, i}
        <li><a href="#/{url}" class:active="{active === url}">{name}</a></li>
        {/each}
        <!-- <li>
          <a
            href="https://www.who.int/data/data-collection-tools/score/documents"
            >Documents</a
          >
        </li> -->
      </ul>
    </section>

    <div class="round-selector">
      <RoundSelect id="score-round-selector" bind:value={selectedRound} />
    </div>

    <ul class="mobile-menu">
      <!-- <li>
        <a href="https://www.who.int/data/data-collection-tools/score">Home</a>
      </li> -->
      {#each items as { name, url }, i}
      <li><a href="#/{url}" class:active="{active === url}">{name}</a></li>
      {/each}
      <!-- <li>
        <a href="https://www.who.int/data/data-collection-tools/score/documents">Documents</a>
      </li> -->

      <li class="mobile-menu__round">
        <RoundSelect id="score-round-selector-mobile" bind:value={selectedRound} />
      </li>
    </ul>
  </nav>
</header>
<datalist id="locations-list">
  {#each countries as c}
  <option value="{c.country}">{c.iso}</option>
  {/each} {#each regions as r}
  <option value="{regionLabel(r)}">{r}</option>
  {/each}
</datalist>
<datalist id="countries-list">
  {#each countries as c}
  <option value="{c.country}">{c.iso}</option>
  {/each}
</datalist>
